@if(content().thumnail_url){
<img src="" class="thumbnail" alt="">-
} @else {
<div class="thumbnail placeholder">
    <kin-icon name="picture" color="white" />
</div>
}

<div class="main-data">
    <p class="content-title">{{content().title}}</p>
    <div class="content-type">
        <kin-icon [size]="16" [name]="icon" [color]="colorService.neutral600()" />
        <p>{{ 'content_type.' + content().content_type | translate | upperFirstLetter}}</p>
    </div>
</div>
<div class="country-language">
    <div class="data">
        <img class="flag" [src]="countryService.getFlagUrl('fr')()" alt="">
        <p class="data">France</p>
    </div>
    <p class="label">{{ 'content_list_element.country' | translate }}</p>
</div>

<div class="sport">
    <kin-icon name="running" />
    <p class="label">{{ 'content_list_element.sport' | translate }}</p>
</div>

<div class="level">
    <p class="data">
        <span class="dot"></span>
        {{'moyen'}}
    </p>
    <p class="label">{{ 'content_list_element.level' | translate }}</p>
</div>

<div class="upload-date">
    <p class="data">{{content().created_at | date:'shortDate'}}</p>
    <p class="label">{{ 'content_list_element.upload' | translate }}</p>
</div>